import React from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

import { eventTypeIcon } from "./operationFieldEventsSummary";
import {
  formatPanelReadingDisplay,
  normalizeMeterType,
  resolveMeterPresentation,
  resolvePanelReadingValue,
  METER_BOTH,
  METER_HOUR,
} from "../FieldApp/fieldAppMeterLabels";

function formatEventMeterReading(event, meterType, t) {
  const presentation = resolveMeterPresentation(meterType, t);
  if (presentation.meterType === METER_BOTH) {
    const parts = [];
    if (event.hourMeter != null && event.hourMeter !== "") {
      parts.push(`${t("Horímetro")} ${event.hourMeter}`);
    }
    if (event.odometer != null && event.odometer !== "") {
      parts.push(`${t("Hodômetro")} ${formatPanelReadingDisplay(event.odometer, "odometer")}`);
    }
    return parts.length ? parts.join(" · ") : null;
  }

  const reading = resolvePanelReadingValue(event, meterType);
  if (reading == null) return null;

  const label =
    normalizeMeterType(meterType) === METER_HOUR
      ? t("Horímetro")
      : t("Hodômetro");
  return `${label}: ${formatPanelReadingDisplay(reading, meterType)}`;
}

export default function OperationFieldEventsPanel({
  events,
  summary,
  expanded,
  onToggle,
  formatTimestamp,
  onOpenPhoto,
  meterType,
  t,
}) {
  if (!events || !events.length) return null;

  const chips = [
    summary.fuelCount > 0
      ? `${summary.fuelCount} ${t("abast.")} · ${summary.totalLiters} L`
      : null,
    summary.assumeCount > 0
      ? `${summary.assumeCount} ${t("assumir máquina")}`
      : null,
    summary.finishCount > 0
      ? `${summary.finishCount} ${t("finalizar")}`
      : null,
    summary.photoCount > 0
      ? `${summary.photoCount} ${t("com foto")}`
      : null,
  ].filter(Boolean);

  return (
    <div className="operation-field-events-panel">
      <div className="operation-field-events-panel-header">
        <div>
          <strong>{t("Eventos de campo")}</strong>
          {chips.length ? (
            <div className="operation-field-events-chips">
              {chips.map((chip) => (
                <span key={chip} className="operation-field-events-chip">
                  {chip}
                </span>
              ))}
            </div>
          ) : (
            <p className="operation-field-events-empty-hint">
              {t("Nenhum abastecimento ou assumir máquina neste período.")}
            </p>
          )}
        </div>
        <button
          type="button"
          className="btn btn-xs btn-default operation-field-events-toggle"
          onClick={onToggle}
          aria-expanded={expanded}
        >
          {expanded ? (
            <>
              <FaChevronUp aria-hidden /> {t("Ocultar detalhes")}
            </>
          ) : (
            <>
              <FaChevronDown aria-hidden /> {t("Ver detalhes")} ({events.length})
            </>
          )}
        </button>
      </div>

      {expanded ? (
        <div className="operation-field-events-grid">
          {events.map((event, index) => {
            const meterReading = formatEventMeterReading(event, meterType, t);
            return (
            <article
              key={`${event.type}-${event.timestamp}-${index}`}
              className="operation-field-event-card"
            >
              <div className="operation-field-event-card-head">
                <span className="operation-field-event-icon" aria-hidden>
                  {eventTypeIcon(event.type)}
                </span>
                <div>
                  <strong>{event.label}</strong>
                  <div className="operation-field-event-time">
                    {formatTimestamp(event.timestamp)}
                  </div>
                </div>
              </div>
              {event.operatorName ? (
                <div className="operation-field-event-meta">
                  {event.operatorName}
                </div>
              ) : null}
              {event.liters != null ? (
                <div className="operation-field-event-meta">
                  {event.liters} L
                  {meterReading ? ` · ${meterReading}` : ""}
                </div>
              ) : meterReading ? (
                <div className="operation-field-event-meta">
                  {meterReading}
                </div>
              ) : null}
              {event.hasPanelPhoto && event.panelPhotoUrl ? (
                <button
                  type="button"
                  className="operation-field-event-photo-thumb"
                  onClick={() => onOpenPhoto(event.panelPhotoUrl)}
                  title={t("Ver foto do painel")}
                >
                  <img
                    src={event.panelPhotoUrl}
                    alt={t("Foto do painel")}
                    loading="lazy"
                  />
                </button>
              ) : event.type === "fueling" || event.type === "assume_machine" ? (
                <span className="operation-field-event-no-photo text-muted">
                  {t("Sem foto sincronizada")}
                </span>
              ) : null}
            </article>
            );
          })}
        </div>
      ) : null}
    </div>
  );
}
